import React from "react"
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import { makeStyles } from '@material-ui/core/styles'
// import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

const useStyles = makeStyles({
    root: {
      minWidth: 300,
      maxWidth: 650
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)'
    },
    title: {
      fontSize: 14
    },
    pos: {
      marginBottom: 12
    }
  })

export const AppCoopAssociationCard = ({ associationData }) => {

  if (!associationData) {
    return <div className="App-w-100" />
  }
  const classes = useStyles()

  return (
    <div className="App-w-100 ">
    <Card className={classes.root} variant="outlined">
    <CardContent>
    <Typography
      className={classes.title}
      color="textSecondary"
      gutterBottom>
        {associationData.field_1}
      </Typography>
      <Typography variant="h5" component="h2">
       {associationData.Title}
      </Typography>
      { (associationData.primaryContact) ? (
          <div>
            <br />
      <Typography
      className={classes.title}
      color="textSecondary"
      gutterBottom>
        PRIMARY CONTACT
      </Typography>
      <Typography variant="h6" component="h4">
       {associationData.primaryContact?.Full_x0020_Name}
      </Typography>
      <Typography variant="body2" component="p">
        Phone: {associationData.field_8}
        <br />
        {
            associationData.field_9 ? (<span>Fax: {associationData.field_9} <br /></span>) : (<span />)
        }
        Address:<br />
        {associationData.field_3}
        <br />
        {
            associationData.field_4 ? (<span>{associationData.field_4} <br /></span>) : (<span />)
        }
        {
            associationData.field_5 ? (<span>{associationData.field_5}</span>) : (<span />)
        }
        {
            associationData.field_6 ? (<span> / {associationData.field_6} <br /></span>) : (<span />)
        }
        {
            associationData.field_7 ? (<span>Email: {associationData.field_7} <br /></span>) : (<span />)
        }
        {
            associationData.field_10 ?
            (<a
              href={associationData.field_10}
              target="_blank"
              rel="noreferrer">{associationData.field_10}</a>) : (<span />)
        }
      </Typography>
      </div>) : (<br />)}
      { (associationData.ambassador) ? (
          <div>
              <br />
            <Divider />
            <br />
        <Typography
      className={classes.title}
      color="textSecondary"
      gutterBottom>
        GLOBAL AMBASSADOR
      </Typography>
      <Typography variant="h6" component="h4">
       {associationData.ambassador?.Full_x0020_Name}
      </Typography>
      <Typography variant="body2" component="p">
        Phone: {associationData.ambassador.PhoneNumber}
        <br />
        {
            associationData.ambassador.Fax_x0020_Number ?
            (<span>Fax: {associationData.ambassador.Fax_x0020_Number} <br /></span>) : (<span />)
        }
        Address:<br />
        {associationData.ambassador.AddressLine1}
        <br />
        {
            associationData.ambassador.AddressLine2 ?
            (<span>{associationData.ambassador.AddressLine2} <br /></span>) : (<span />)
        }
        {
            associationData.ambassador.City ?
            (<span>{associationData.ambassador.City} <br /></span>) : (<span />)
        }
        {
            associationData.ambassador.State ?
            (<span> {associationData.ambassador.State}</span>) : (<span />)
        }
        {
            associationData.ambassador.Country ?
            (<span> / {associationData.ambassador.Country} <br /></span>) : (<span />)
        }
        {
            associationData.ambassador.E_x002d_mail ?
            (<span>Email: {associationData.ambassador.E_x002d_mail} <br /></span>) : (<span />)
        }
      </Typography>
      </div>) : (<br />)}
      { (associationData.coordinator) ? (
        <div>
            <br />
            <Divider />
            <br />
        <Typography
      className={classes.title}
      color="textSecondary"
      gutterBottom>
        GLOBAL COORDINATOR
      </Typography>
      <Typography variant="h6" component="h4">
       {associationData.coordinator?.Title}
      </Typography>
      <Typography variant="body2" component="p">
        Phone: {associationData.coordinator.PhoneNumber}
        <br />
        {
            associationData.coordinator.Fax ?
            (<span>Fax: {associationData.coordinator.Fax} <br /></span>) : (<span />)
        }
        Address:<br />
        {associationData.coordinator.AddressLine1}
        <br />
        {
            associationData.coordinator.AddressLine2 ?
            (<span>{associationData.coordinator.AddressLine2} <br /></span>) : (<span />)
        }
        {
            associationData.coordinator.City ?
            (<span>{associationData.coordinator.City} <br /></span>) : (<span />)
        }
        {
            associationData.coordinator.State ?
            (<span> {associationData.coordinator.State} </span>) : (<span />)
        }
        {
            associationData.coordinator.Country ?
            (<span> / {associationData.coordinator.Country} <br /></span>) : (<span />)
        }
        {
            associationData.coordinator.Email ?
            (<span>Email: {associationData.coordinator.Email} <br /></span>) : (<span />)
        }
      </Typography>
      </div>) : (<br />)}
      { (associationData.ambassadorAssociation) ? (
          <div>
            <br />
            <Divider />
            <br />
        <Typography
      className={classes.title}
      color="textSecondary"
      gutterBottom>
        AMBASSADOR ASSOCIATION CONTACT
      </Typography>
      <Typography variant="h5" component="h4">
       {associationData.ambassadorAssociation?.Full_x0020_Name}
      </Typography>
      { (associationData.ambassadorAssociation) ? (
      <Typography variant="body2" component="p">
        <strong>{associationData.ambassadorAssociation.Staff_x0020_Contact}</strong><br />
        Phone: {associationData.ambassadorAssociation.Phone_x0020_Number}
        <br />
        {
            associationData.ambassadorAssociation.Fax ?
            (<span>Fax: {associationData.ambassadorAssociation.Fax} <br /></span>) : (<span />)
        }
        Address:<br />
        {associationData.ambassadorAssociation.Address_x0020_Line1}
        <br />
        {
            associationData.ambassadorAssociation.Address_x0020_Line2 ?
            (<span>{associationData.ambassadorAssociation.Address_x0020_Line2} <br /></span>) : (<span />)
        }
        {
            associationData.ambassadorAssociation.City ?
            (<span>{associationData.ambassadorAssociation.City} <br /></span>) : (<span />)
        }
        {
            associationData.ambassadorAssociation.State ?
            (<span> {associationData.ambassadorAssociation.State} </span>) : (<span />)
        }
        {
            associationData.ambassadorAssociation.Country ?
            (<span> / {associationData.ambassadorAssociation.Country} <br /></span>) : (<span />)
        }
        {
            associationData.ambassadorAssociation.Email ?
            (<span>Email: {associationData.ambassadorAssociation.Email} <br /></span>) : (<span />)
        }
      </Typography>)
      : (<br />)}
      </div>) : (<br />)}
    </CardContent>
    <CardActions>
    </CardActions>
  </Card>
  </div>
  )
}
